module.exports = __webpack_public_path__ + "media/images/landing/second/photo2-11629e040f7a9eeed33338a52afed324.jpg";